module.exports = __webpack_public_path__ + "img/Google play logo.08c7171f.png";